import { InjectionToken } from '@angular/core';
import { LogLayerConfig } from 'loglayer';

export const LOG_LAYER_CONFIG = new InjectionToken<LogLayerConfig>('LOG_LAYER_CONFIG');
